const getLedgerQuery = `
select * from avocado.get_ledger ($1);
`
module.exports = getLedgerQuery
